<template>
    <div class="d-flex flex-column" style="min-height: 100vh;">
        <Toasts :firebase-uid="$page.props.auth_uid"/>
        <StoreHeader v-if="$page.props.store" :store="$page.props.store"/>
        <FlashMessages/>

        <div class="flex-grow-1" :class="{'mx-5 mt-5': !noGutters}">
            <div class="d-flex flex-column gap-2">
                <Toolbar>
                    <!-- BACK BUTTON -->
                    <div>
                        <a :href="$route('integrations.index')"
                           class="btn btn-secondary btn-hover-primary bg-white">
                            <i class="fas fa-arrow-circle-left"/>
                            <span class="px-1">{{ __('general.integrations') }}</span>
                        </a>
                    </div>

                    <!-- DISABLE BUTTON -->
                    <template v-slot:right>
                        <button class="btn btn-secondary btn-hover-danger bg-white" @click="disable">
                            <i class="fas fa-ban"/>
                            <span class="px-1">{{
                                    __('actions.disable_thing', {thing: integration.name})
                                }}</span>
                        </button>
                    </template>
                </Toolbar>

                <IntegrationSettingsHeader :integration="integration"/>

                <!-- TODO: use tabs instead of stacking cards -->

                <slot/>

                <IntegrationSettingsStores v-if="linksStores"
                                           :integration="integration"
                                           :available-stores="stores"
                                           :enabled-stores="enabledStores"
                                           :disabled="disableStoreCard"
                />

                <IntegrationSettingsOAuth v-if="hasOAuth"
                                          :integration="integration"
                />
            </div>
        </div>

        <PageFooter v-if="!noGutters"/>
    </div>
</template>

<script>
import IntegrationSettingsStores from '../components/Integrations/IntegrationSettingsStores.vue';
import IntegrationSettingsOAuth from '../components/Integrations/IntegrationSettingsOAuth.vue';
import IntegrationSettingsHeader from '../components/Integrations/IntegrationSettingsHeader.vue';
import IntegrationSettingsAddStores from '../components/Integrations/IntegrationSettingsAddStores.vue';
import IntegrationSettingsStoreList from '../components/Integrations/IntegrationSettingsStoreList.vue';
import ToggleModel from '../components/ToggleModel.vue';
import StoreHeader from '../components/Store/StoreHeader.vue';
import Toasts from '../components/Toasts.vue';
import PageFooter from './Includes/PageFooter.vue';
import FlashMessages from '../components/FlashMessages.vue';
import Toolbar from '@components/Toolbar.vue';
import Aside from '@components/Navigation/Aside.vue';

export default {
    components: {
        Aside,
        Toolbar,
        FlashMessages,
        PageFooter,
        Toasts,
        StoreHeader,
        IntegrationSettingsStores,
        IntegrationSettingsOAuth,
        IntegrationSettingsHeader,
        IntegrationSettingsAddStores,
        IntegrationSettingsStoreList,
        ToggleModel,
    },

    props: {
        disableStoreCard: Boolean,
        noGutters: Boolean,
    },

    methods: {
        disable() {
            Swal.fire({
                title: __('actions.disable_thing', {thing: this.integration.name}) + '?',
                text: __('integrations.you_loose_functionality_warning'),
                showCancelButton: true,
                confirmButtonText: __('general.yes'),
                cancelButtonText: __('actions.abort'),
                customClass: {
                    confirmButton: 'btn btn-danger m-0',
                },
            }).then((result) => {
                if (result.value) {
                    this.$inertia.visit(this.$route('integration.disable', [this.integration.code]));
                }
            });
        },
    },

    computed: {
        integration() {
            return this.$page.props.integration;
        },

        enabledStores() {
            return this.$page.props.enabledStores;
        },

        stores() {
            return this.$page.props.stores;
        },

        hasOAuth() {
            return this.$page.props.integration.abilities.includes('HasOAuth');
        },

        linksStores() {
            return this.$page.props.integration.abilities.includes('LinksStores');
        },
    },
};
</script>
